import { Box, Tooltip, Typography } from "@mui/material";
import CallDetails from "./CallDetails";
import InfoIcon from "@mui/icons-material/Info";

const CallOverview = ({
  overview,
  data,
  customerAnalytics,
  agentAnalytics,
  transcript,
  setValue,
}) => {

  return (

    <>
      <Box>
        <Typography
          variant="h5"
          component="h1"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          Call Overview
          <Tooltip
            title="Gives the overview of the call and the sentimental analysis"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoIcon
              sx={{
                fontSize: 18,
                color: "grey",
              }}
            />
          </Tooltip>
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          A centralized dashboard for Quality Analysts to review, score, and act
          upon single recordings using AI-powered insights.
        </Typography>
      </Box>
      <Box>
        {/* <CallHeader overview={overview} data={data} /> */}
        <CallDetails
          overview={overview}
          data={data}
          customerAnalytics={customerAnalytics}
          agentAnalytics={agentAnalytics}
          transcript={transcript}
          setValue={setValue}
        />
      </Box>

    </>
  );
};

export default CallOverview;
